import { get } from "./request";

/**
 * 教师统计（Teacher Statistics Controller）
 * base: /courseAdmin/course/statistics/teacher
 *
 * 面板 ↔ 接口：
 * - 概览卡片      → overview
 * - 课程赛道      → courseTrack（学习体系分布 + percentage）
 * - 学习完成率    → learningCompletion（completionRate）
 * - 课程分布      → courseDistribution（学习体系课程数）
 * - 课程排行榜    → courseRanking（studyCount / learnerCount）
 * - 学员增长趋势  → studentGrowth?days=
 * - 课程类型      → courseType（count / percentage）
 * - 月度活跃热力  → dailyActive（date + activeMemberCount）
 */
const TEACHER_STATS = "/courseAdmin/course/statistics/teacher";

/** 教师统计概览 */
export function getTeacherOverview() {
  return get(`${TEACHER_STATS}/overview`);
}

/** 教师课程赛道分布 */
export function getTeacherCourseTrack() {
  return get(`${TEACHER_STATS}/courseTrack`);
}

/** 教师课程学习完成率 */
export function getTeacherLearningCompletion() {
  return get(`${TEACHER_STATS}/learningCompletion`);
}

/** 教师课程分布（按学习体系） */
export function getTeacherCourseDistribution() {
  return get(`${TEACHER_STATS}/courseDistribution`);
}

/** 教师课程排行榜 */
export function getTeacherCourseRanking() {
  return get(`${TEACHER_STATS}/courseRanking`);
}

/** 教师学员增长趋势（默认近 7 天） */
export function getTeacherStudentGrowth(params) {
  return get(`${TEACHER_STATS}/studentGrowth`, params);
}

/** 教师课程类型统计 */
export function getTeacherCourseType() {
  return get(`${TEACHER_STATS}/courseType`);
}

/** 教师每日学习活跃人数 [{ date, activeMemberCount }] */
export function getTeacherDailyActive() {
  return get(`${TEACHER_STATS}/dailyActive`);
}



// WEBPACK FOOTER //
// ./src/api/home.js